import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import CategoriesSectionContainer from './CategoriesSectionContainer';

const MobileShopByCategoryToggle = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="block md:hidden bg-gray-50" style={{ minHeight: '56px' }}>
      <div className="container-custom py-4">
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          variant="outline"
          className="w-full flex items-center justify-center gap-2 border-springbok-300 text-springbok-700 hover:bg-springbok-50"
        >
          Shop by Category
          {isExpanded ? (
            <ChevronUp className="h-4 w-4" />
          ) : (
            <ChevronDown className="h-4 w-4" />
          )}
        </Button>
      </div>
      
      {isExpanded && (
        <div className="animate-in slide-in-from-top-2 duration-200">
          <CategoriesSectionContainer />
        </div>
      )}
    </div>
  );
};

export default MobileShopByCategoryToggle;